import { Navigate, Route, Routes } from 'react-router-dom';
import { PortalLoginPage, PortalRegisterPage } from '@/features/auth';
import { HomePage } from '@/features/home';
import { AppointmentsPage, ClinicDiscoveryPage } from '@/features/appointments';
import { RecordsPage } from '@/features/records';
import { BillingPage } from '@/features/billing';
import { ProfilesPage } from '@/features/profiles';
import { SharedDocumentPage } from '@/features/sharedDocuments';
import { ProtectedRoute } from './ProtectedRoute';
import { ActiveProfileRoute } from './ActiveProfileRoute';
import { PortalShell } from './shells/PortalShell';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<PortalLoginPage />} />
      <Route path="/register" element={<PortalRegisterPage />} />
      {/* Public, login-less guest document viewer — outside ProtectedRoute and PortalShell. */}
      <Route path="/shared/:token" element={<SharedDocumentPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<PortalShell />}>
          <Route index element={<HomePage />} />
          <Route path="profile" element={<ProfilesPage />} />
          <Route path="find-care" element={<ClinicDiscoveryPage />} />
          <Route element={<ActiveProfileRoute />}>
            <Route path="appointments" element={<AppointmentsPage />} />
            <Route path="records" element={<RecordsPage />} />
            <Route path="billing" element={<BillingPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
